import { Injectable, OnDestroy } from '@angular/core';

import { fuseConfig } from 'app/fuse-config';
import { FuseConfig } from '@fuse/types';
import { HttpClient } from '@angular/common/http';
import { Subject, BehaviorSubject, Subscription, Observable } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

export interface IsNewResponse {
    data: number;
}

@Injectable()

export class ComplaintService implements OnDestroy {
    public _unsubscribeAll: Subject<any>;
    public _fuseConfig: FuseConfig;

    timer: Observable<number>;
    timerSubscription: Subscription;

    onComplaintsChanged: BehaviorSubject<any>;

    // fromNotifications = false;

    searchText: string;

    constructor(
        public _http: HttpClient,
    ) {
        this._fuseConfig = fuseConfig;
        this._unsubscribeAll = new Subject();

        this.onComplaintsChanged = new BehaviorSubject({});

    }

    /**
     * Public methods
     */

    public listSubmittedComplaints(companyId, page: number = 1, limit: number = 10, orderBy: string = 'created_at', order: string = 'desc', search: string = ''): Promise<any> {

        const params = {
            limit: limit,
            order_by: 'id',
            order: order
        };

        return new Promise((resolve, reject) => {
            this._http.post(this._fuseConfig.api.url + '/portal/erp/' + companyId + '/complaint/listing?page=' + page, params)
                .pipe(takeUntil(this._unsubscribeAll))
                .subscribe(
                    response => {
                        this.onComplaintsChanged.next(response);
                        resolve(response);
                    }, reject);
        });

    }

    public createComplaint(complaintCategoryId: number, comment: string, company: string): Promise<any> {

        const params = {
            complaint_category_id: complaintCategoryId,
            complaint: comment
        };

        return new Promise((resolve, reject) => {
            this._http.post(this._fuseConfig.api.url + '/portal/erp/' + company + '/complaint/submit', params)
                .pipe(takeUntil(this._unsubscribeAll))
                .subscribe(
                    response => {
                        this.listSubmittedComplaints(company);
                        resolve(response);
                    }, reject);
        });
    }

    public getAllComplaintTypes(company: number): Promise<any> {
        return new Promise((resolve, reject) => {
            this._http.get(this._fuseConfig.api.url + '/portal/erp/' + company + '/complaint/get-categories')
                .pipe(takeUntil(this._unsubscribeAll))
                .subscribe(
                    response => {
                        resolve(response);
                    }, reject);
        });
    }
    
    /**
     * Lifecycle hooks
     */

    ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }
}
